import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from '../services/config.service';
import { TenantUtil } from '../utils/tenant.util';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const configService = inject(ConfigService);
  const headers: Record<string, string> = {};

  // Don't set Content-Type for FormData - let the browser set it with the boundary
  if (!req.headers.has('Content-Type') && !(req.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  headers['X-Host'] = `${document.location.protocol}//${document.location.host}`;


  const { environment } = configService.app;

  if (environment) {
    headers['X-Tenant'] = TenantUtil.getCurrentTenant(environment);
  }

  const clonedReq = req.clone({
    setHeaders: headers,
  });

  return next(clonedReq);
};

